import axios from 'axios';

/* Storage */
import { getUser } from '../helpers/storage';

/* Utils */
import PathsBasic from '../utils/paths/pathsBasic';

axios.interceptors.request.use((config) => {
  const urlservice = config.url;
  const hasPath = PathsBasic.some(path => urlservice.includes(path));
  let token = getUser().token !== null && getUser().token;
  if ( hasPath ){
    config.headers.Authorization = `Bearer ${process.env.REACT_APP_TOKEN_INSIDE}`;
  } else {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
},
(error) => {
  return Promise.resolve(error.message);
});
